module.exports = __webpack_public_path__ + "img/weixin.450d2b76.450d2b76.jpg";